import { useQuery } from '@apollo/client'
import {
  ConsoleSignInOptionsQuery,
  ConsoleSignInOptionsQueryVariables,
} from 'src/generated'

import QUERY from './consoleSignInOptionsQuery.gql'

/**
 * Which ways in this console offers, asked before anybody is signed in: the
 * Continue with Google and Continue with Apple buttons are drawn only where
 * each is set up. Anonymous, like every request a signed-out page makes: the
 * client stops any other before it is sent when nobody is signed in, which
 * left the sign-in page with neither button.
 */
export const useConsoleSignInOptionsQuery = () =>
  useQuery<ConsoleSignInOptionsQuery, ConsoleSignInOptionsQueryVariables>(
    QUERY,
    { context: { anonymous: true } },
  )
